import { orderBy } from 'lodash';

import type { CustomFormula } from './types';

export const sortCustomFormulas = (items: CustomFormula[]): CustomFormula[] =>
  orderBy(items, ['generationTool', 'name', 'updatedAt', 'id'], ['asc', 'asc', 'desc', 'asc']);
